if (typeof Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.theme.jsAjaxCart = {
  init: function () {
    this.loadCartContents();
    this.event_open = new Event('e_ajax-cart-opened');
    this.event_change = new Event('e_ajax-cart-changed');
    this.event_closed = new Event('e_ajax-cart-closed');
    let openButton = document.querySelector('[data-ajax-cart-trigger]');
    let closeButton = document.querySelector('[data-ajax-cart-close]');
    let ajaxCartOverlay = document.querySelector('[data-ajax-cart-overlay]');
    openButton.addEventListener('click', event => {
      this.onCartOpen();
    });
    closeButton.addEventListener('click', event => {
      this.onCartClose();
    });
    ajaxCartOverlay.addEventListener('click', event => {
      this.onCartClose();
    });
  },
  addCartEvents: function () {
    var event = new Event('change');

    function updateInputQuantity() {
      let wrapper = this.closest('[data-cart-item-quantity-wrapper]'),
          input = wrapper.querySelector('[data-cart-item-quantity'),
          minus = wrapper.querySelector('[data-cart-item-quantity-minus'),
          plus = wrapper.querySelector('[data-cart-item-quantity-plus'),
          count,
          valMax = input.getAttribute('max'),
          valMin = input.getAttribute('min');

      if (this === minus) {
        count = parseInt(input.value) - 1;
      } else {
        count = parseInt(input.value) + 1;
      }

      if (count > valMax) {
        input.value = valMax;
        plus.disabled = true;
        minus.disabled = false;
        input.dispatchEvent(event);
      } else if (count < valMin) {
        input.value = valMin;
        minus.disabled = true;
        plus.disabled = false;
        input.dispatchEvent(event);
      } else {
        minus.disabled = false;
        plus.disabled = false;
        input.value = count;
        input.dispatchEvent(event);
      }

      return false;
    }

    [...document.querySelectorAll('[data-cart-item-quantity-minus]')].forEach(minus => {
      minus.addEventListener('click', updateInputQuantity);
    });
    [...document.querySelectorAll('[data-cart-item-quantity-plus]')].forEach(plus => {
      plus.addEventListener('click', updateInputQuantity);
    });
    [...document.querySelectorAll('[data-cart-item-quantity]')].forEach(qty => {
      qty.addEventListener('change', this.changeQty);
    });
    [...document.querySelectorAll('[data-cart-item-remove]')].forEach(button => {
      button.addEventListener('click', this.removeLineItem);
    });
    let checkCartContinue = document.querySelector('[data-ajax-cart-continue]');

    if (typeof checkCartContinue !== 'undefined' && checkCartContinue !== null) {
      document.querySelector('[data-ajax-cart-continue]').addEventListener('click', event => {
        this.onCartClose();
      });
    }
  },
  changeQty: event => {
    var item = event.currentTarget,
        params = JSON.stringify({
      line: item.dataset.cartItemIndex,
      quantity: item.value
    });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: params
    }).then(response => response.json()).then(data => {
      [...document.querySelectorAll(`[data-cart-item-quantity][data-cart-item-index="${item.dataset.cartItemIndex}"]`)].forEach(qty => {
        qty.value = item.value;
      });
      Shopify.theme.jsAjaxCart.onCartChange(data);
    }).catch(error => console.error(`AJAX Cart quantity change error: ${error}`));
  },
  closeCart: function () {
    document.querySelector('[data-ajax-cart]').classList.remove('is-open');
    this.onCartClose();
  },
  loadCartContents: async function () {
    fetch('/cart?view=ajax').then(response => response.text()).then(html => {
      if (document.querySelector('[data-ajax-cart-contents]') !== null && typeof document.querySelector('[data-ajax-cart-contents]') !== 'undefined') {
        document.querySelector('[data-ajax-cart-contents]').innerHTML = html;
        document.dispatchEvent(new Event('e_cartupdated'));
      }

      this.addCartEvents();
    }).catch(error => console.error(`AJAX Cart load error: ${error}`));
  },
  removeLineItem: event => {
    var item = event.currentTarget,
        params = JSON.stringify({
      line: item.dataset.cartItemIndex,
      quantity: 0
    });
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: params
    }).then(response => response.json()).then(data => {
      // animate removal of line item (ajax and page)
      document.querySelectorAll(`[data-cart-item][data-cart-item-index="${item.dataset.cartItemIndex}"]`).forEach(item => item.remove());
      document.dispatchEvent(new Event('e_cartupdated'));
      Shopify.theme.jsAjaxCart.onCartChange();
    }).catch(error => console.error(`AJAX Cart item remove error: ${error}`));
  },
  onCartChange: function (data) {
    if (data === undefined) {
      this.loadCartContents();
    } else {
      // Update line item subtotals
      // ...
      // Update cart total
      document.querySelectorAll('[data-cart-total]').forEach(total => total.innerText = Utils.formatMoney(data.total_price / 100));
      document.dispatchEvent(this.event_change);
      document.dispatchEvent(new Event('e_cartupdated'));
    }

    if (typeof Shopify.theme.jsCartCounter !== 'undefined') {
      Shopify.theme.jsCartCounter.update();
    }
  },
  onCartClose: function () {
    if (Shopify.theme.settings.cart_action == 'ajaxcart') {
      document.querySelector('[data-ajax-cart]').classList.remove('is-open');
      document.dispatchEvent(this.event_closed);
    }
  },
  onCartOpen: function () {
    if (Shopify.theme.settings.cart_action == 'ajaxcart') {
      let checkCart = document.querySelector('[data-ajax-cart]');

      if (typeof checkCart !== 'undefined' && checkCart !== null) {
        document.querySelector('[data-ajax-cart]').classList.add('is-open');
        document.dispatchEvent(this.event_open);
      }
    }
  },
  openCart: function () {
    document.querySelector('[data-ajax-cart] button').click();
    this.onCartOpen();
  }
};

(() => {
  Shopify.theme.jsAjaxCart.init();
})();
